// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Caml_exceptions = require("rescript/lib/js/caml_exceptions.js");
var Nps$ReactHooksTemplate = require("./Nps.res.js");
var Csat$ReactHooksTemplate = require("./csat.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var NumberType$ReactHooksTemplate = require("../data_fields/numberType.res.js");
var StarRating$ReactHooksTemplate = require("./StarRating.res.js");
var RatingGroup$ReactHooksTemplate = require("./RatingGroup.res.js");
var OpinionScale$ReactHooksTemplate = require("./OpinionScale.res.js");
var SmileyRating$ReactHooksTemplate = require("./smileyRating.res.js");

var AnswerNotFound = /* @__PURE__ */Caml_exceptions.create("NumberCondition-ReactHooksTemplate.AnswerNotFound");

var ValueNotFound = /* @__PURE__ */Caml_exceptions.create("NumberCondition-ReactHooksTemplate.ValueNotFound");

function lhs(t) {
  return t.lhs;
}

function operator(t) {
  return t.operator;
}

function rhs(t) {
  return t.rhs;
}

function groupId(t) {
  return t.groupId;
}

function setLhs(t, lhs) {
  return {
          lhs: lhs,
          operator: t.operator,
          rhs: t.rhs,
          groupId: t.groupId
        };
}

function setOperator(t, operator) {
  return {
          lhs: t.lhs,
          operator: operator,
          rhs: t.rhs,
          groupId: t.groupId
        };
}

function setGroupId(t, groupId) {
  return {
          lhs: t.lhs,
          operator: t.operator,
          rhs: t.rhs,
          groupId: groupId
        };
}

function setRhs(t, rhs) {
  return {
          lhs: t.lhs,
          operator: t.operator,
          rhs: rhs,
          groupId: t.groupId
        };
}

function getAnswer(question) {
  var smileyRating = question.questionType;
  switch (smileyRating.TAG) {
    case "OpinionScale" :
        return OpinionScale$ReactHooksTemplate.answerToInt(smileyRating._0);
    case "StarRating" :
        return StarRating$ReactHooksTemplate.answerToInt(smileyRating._0);
    case "Nps" :
        return Nps$ReactHooksTemplate.answerToInt(smileyRating._0);
    case "SmileyRating" :
        return SmileyRating$ReactHooksTemplate.answerToInt(smileyRating._0);
    case "Csat" :
        return Csat$ReactHooksTemplate.answerToInt(smileyRating._0);
    default:
      return ;
  }
}

function ratingGroupAnswer(question) {
  var ratingGroup = Question$ReactHooksTemplate.questionType(question);
  if (ratingGroup.TAG === "RatingGroup") {
    return RatingGroup$ReactHooksTemplate.answer(ratingGroup._0);
  }
  
}

function getValue(dataField) {
  var numberType = DataField$ReactHooksTemplate.dataType(dataField);
  if (numberType.TAG === "NumberType") {
    return NumberType$ReactHooksTemplate.value(numberType._0);
  }
  
}

function humanizeOperator(text, t) {
  switch (text) {
    case "equals" :
        return "Equals";
    case "greater_than" :
        return "Greater Than";
    case "greater_than_or_equal_to" :
        return "Greater Than Or Equal To";
    case "is_blank" :
        var match = t.lhs;
        if (match.TAG === "Question") {
          return "Is Not Answered";
        } else {
          return "Is Blank";
        }
    case "is_not_blank" :
        var match$1 = t.lhs;
        if (match$1.TAG === "Question") {
          return "Is Answered";
        } else {
          return "Is Not Blank";
        }
    case "less_than" :
        return "Less Than";
    case "less_than_or_equal_to" :
        return "Less Than Or Equal To";
    case "not_equals" :
        return "Not Equals";
    default:
      return "";
  }
}

function evalBlankCase(t) {
  var match = t.operator;
  switch (match) {
    case "is_blank" :
    case "not_equals" :
        return true;
    default:
      return false;
  }
}

function evalNonBlankCase(value, rhs, t) {
  var match = t.operator;
  switch (match) {
    case "equals" :
        return Caml_obj.equal(value, rhs);
    case "greater_than" :
        return Caml_obj.greaterthan(value, rhs);
    case "greater_than_or_equal_to" :
        return Caml_obj.greaterequal(value, rhs);
    case "less_than" :
        return Caml_obj.lessthan(value, rhs);
    case "less_than_or_equal_to" :
        return Caml_obj.lessequal(value, rhs);
    case "not_equals" :
        return Caml_obj.notequal(value, rhs);
    default:
      return false;
  }
}

function evaluate(t) {
  var question = t.lhs;
  if (question.TAG === "Question") {
    var question$1 = question._0;
    if (!Question$ReactHooksTemplate.answered(question$1)) {
      return evalBlankCase(t);
    }
    var match = t.operator;
    switch (match) {
      case "is_blank" :
          return false;
      case "is_not_blank" :
          return true;
      default:
        var ratingGroup = Question$ReactHooksTemplate.questionType(question$1);
        if (ratingGroup.TAG === "RatingGroup") {
          var match$1 = ratingGroupAnswer(question$1);
          var match$2 = t.rhs;
          if (match$1 !== undefined) {
            if (match$2 !== undefined) {
              var id = t.groupId;
              if (id !== undefined) {
                return Belt_List.has(Belt_List.map(match$1, (function (param) {
                                  if (param[0] === id) {
                                    return evalNonBlankCase(param[1], match$2, t);
                                  } else {
                                    return false;
                                  }
                                })), true, (function (a, b) {
                              return a === b;
                            }));
              }
              var overallRating = RatingGroup$ReactHooksTemplate.overallRating(ratingGroup._0);
              return evalNonBlankCase(overallRating, match$2, t);
            }
            throw {
                  RE_EXN_ID: ValueNotFound,
                  _1: "Expected RHS value, got None for operator: " + t.operator,
                  Error: new Error()
                };
          }
          throw {
                RE_EXN_ID: AnswerNotFound,
                _1: "Answer not found for question",
                Error: new Error()
              };
        }
        var match$3 = getAnswer(question$1);
        var match$4 = t.rhs;
        if (match$3 !== undefined) {
          if (match$4 !== undefined) {
            return evalNonBlankCase(match$3, match$4, t);
          }
          throw {
                RE_EXN_ID: ValueNotFound,
                _1: "Expected RHS value, got None for operator: " + t.operator,
                Error: new Error()
              };
        }
        throw {
              RE_EXN_ID: AnswerNotFound,
              _1: "Answer not found for question",
              Error: new Error()
            };
    }
  } else {
    var value = getValue(question._0);
    var match$5 = t.operator;
    switch (match$5) {
      case "is_blank" :
          return value === undefined;
      case "is_not_blank" :
          return value !== undefined;
      default:
        var match$6 = t.rhs;
        if (value !== undefined) {
          if (match$6 !== undefined) {
            return evalNonBlankCase(value, match$6, t);
          } else {
            return false;
          }
        } else {
          return evalBlankCase(t);
        }
    }
  }
}

function availableOperators(param) {
  return {
          hd: "equals",
          tl: {
            hd: "not_equals",
            tl: {
              hd: "greater_than",
              tl: {
                hd: "less_than",
                tl: {
                  hd: "greater_than_or_equal_to",
                  tl: {
                    hd: "less_than_or_equal_to",
                    tl: {
                      hd: "is_blank",
                      tl: {
                        hd: "is_not_blank",
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

function decodeLhs(json, questions, dataFields) {
  var lhsId = Json_decode.field("lhs_id", Json_decode.$$int, json);
  var lhsType = Json_decode.field("lhs_type", Json_decode.string, json);
  switch (lhsType) {
    case "DataField" :
        return {
                TAG: "DataField",
                _0: List.find((function (n) {
                        return Belt_Option.getExn(DataField$ReactHooksTemplate.id(n)) === lhsId;
                      }), dataFields)
              };
    case "Question" :
        return {
                TAG: "Question",
                _0: List.find((function (n) {
                        return Belt_Option.getExn(Question$ReactHooksTemplate.id(n)) === lhsId;
                      }), questions)
              };
    default:
      return Js_exn.raiseError("Unknown lhs type");
  }
}

function decode(json, questions, dataFields) {
  return {
          lhs: decodeLhs(json, questions, dataFields),
          operator: Json_decode.field("operator", Json_decode.string, json),
          rhs: Json_decode.field("rhs", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          groupId: Json_decode.field("group_id", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json)
        };
}

function answerRange(lhs) {
  if (lhs.TAG !== "Question") {
    return [
            0,
            0
          ];
  }
  var nps = lhs._0.questionType;
  switch (nps.TAG) {
    case "OpinionScale" :
        return OpinionScale$ReactHooksTemplate.answerRange(nps._0);
    case "StarRating" :
        return StarRating$ReactHooksTemplate.answerRange(nps._0);
    case "Nps" :
        return Nps$ReactHooksTemplate.answerRange(nps._0);
    case "RatingGroup" :
        return RatingGroup$ReactHooksTemplate.answerRange(nps._0);
    case "SmileyRating" :
        return SmileyRating$ReactHooksTemplate.answerRange(nps._0);
    case "Csat" :
        return Csat$ReactHooksTemplate.answerRange(nps._0);
    default:
      return [
              0,
              0
            ];
  }
}

function encodeRhs(t) {
  return Json_encode.nullable((function (prim) {
                return prim;
              }), t.rhs);
}

exports.lhs = lhs;
exports.operator = operator;
exports.rhs = rhs;
exports.groupId = groupId;
exports.setGroupId = setGroupId;
exports.setLhs = setLhs;
exports.setOperator = setOperator;
exports.setRhs = setRhs;
exports.evaluate = evaluate;
exports.availableOperators = availableOperators;
exports.decode = decode;
exports.answerRange = answerRange;
exports.humanizeOperator = humanizeOperator;
exports.encodeRhs = encodeRhs;
/* Nps-ReactHooksTemplate Not a pure module */
